import { DataProvider } from 'components/organisms/data-provider'
import { PapeletaService } from '../services/papeleta.service'

export function PapeletaDataProvider({ children, ...props }) {
    return (
        <DataProvider {...props} getDataById={PapeletaService.getById}>
            {children}
        </DataProvider>
    )
}
